import ufeApi from 'services/api/ufeApi';
import { gqlClient } from 'services/api/gql/gqlClient';
import { CheckEligibility } from 'constants/gql/queries/checkout/ncrEligibility.gql';

// https://confluence.sephora.com/wiki/pages/viewpage.action?spaceKey=ILLUMINATE&title=Reason+Codes+API
const getReturnEligibility = async (reasonCode, orderId) => {
    const oxsUrl = `/api/selfReturn/orders/${orderId}/eligibility?reasonCode=${reasonCode}`;

    const globalEnabled = Sephora?.configurationSettings?.oisMigration?.global?.isEnabled;
    const returnsEnabled = Sephora?.configurationSettings?.oisMigration?.returns?.isEnabled;

    if (globalEnabled && returnsEnabled) {
        const data = await gqlClient.query({
            operationName: 'CheckEligibility',
            query: CheckEligibility,
            variables: {
                orderId,
                reasonCode
            }
        });

        const result = data?.ncrEligibility;

        return {
            responseCode: result?.responseCode,
            eligibleForNCR: result?.eligibility?.eligibleForNCR
        };
    }

    const data = await ufeApi.makeRequest(oxsUrl, { method: 'GET' });

    return data.errorCode ? Promise.reject(data) : data;
};

export default getReturnEligibility;
